<mat-card appearance="outlined" *appRoles="['TiposRegistroContable.Listar']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Tipos Registro Contable</h2>
      <app-button-new *appRoles="['TiposRegistroContable.Crear']" (click)="openDialog('Agregar', {})"
        #tooltip="matTooltip" matTooltip="Crear tarea"></app-button-new>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="row">
      <div class="col">
        <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
      </div>
    </div>
    <br />
    <br />
  </mat-card-content>
  <mat-card-content>
   <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spTiposRegistroContable" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" table matSort matSortStart="asc"
      class="mat-elevation-z8">
      <ng-container matColumnDef="descripcion">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          Descripción
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element">
          {{ element.descripcion }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="accion">
        <mat-header-cell mat-header-cell *matHeaderCellDef>
          Acción
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="action-link">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *appRoles="['TiposRegistroContable.Ver']" mat-menu-item
              (click)="openDialog('Ver', element)">
              <mat-icon>visibility</mat-icon>
              <span>Ver</span>
            </button>
            <button *appRoles="['TiposRegistroContable.Modificar']" mat-menu-item
              (click)="openDialog('Modificar', element)">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button *appRoles="['TiposRegistroContable.Eliminar']" mat-menu-item
              (click)="openDialog('Eliminar', element)">
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
    </table>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
    <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
    </mat-paginator>
  </mat-card-content>
</mat-card>
